export function mergeSharedFolderContent(existing, incoming, { canRead, args }) {
    if (!existing) return incoming;
    if (!incoming) return existing;

    const existingMessages = existing?.messages?.messages || [];
    const incomingMessages = incoming?.messages?.messages || [];

    const getMessageId = msg => {
        if (!msg) return null;
        if (msg.__ref) {
            const jsonPart = msg.__ref.replace('Message:', '');
            try {
                return JSON.parse(jsonPart).id;
            } catch (error) {
                return jsonPart;
            }
        }
        return msg.id || null;
    };

    const shouldIncludeMessage = msg => {
        const messageId = getMessageId(msg);
        if (!messageId || String(messageId).startsWith('temp-')) {
            return false;
        }
        return !msg.__ref || canRead(msg);
    };

    const messageMap = new Map();
    existingMessages.forEach(msg => {
        // Keep loaded references during partial preview cache writes.
        const id = getMessageId(msg);
        if (id && !String(id).startsWith('temp-')) {
            messageMap.set(getMessageId(msg), msg);
        }
    });
    incomingMessages.forEach(msg => {
        if (shouldIncludeMessage(msg)) {
            messageMap.set(getMessageId(msg), msg);
        }
    });

    const mergedMessages = Array.from(messageMap.values());
    const isPaginationRequest = Boolean(args?.data?.messageCursor);
    const hasPaginatedData = mergedMessages.length > incomingMessages.length;
    const hasIncomingMessagesCursor =
        Boolean(incoming?.messages) &&
        Object.prototype.hasOwnProperty.call(incoming.messages, 'cursor');

    let cursor;
    if (isPaginationRequest) {
        cursor = hasIncomingMessagesCursor
            ? incoming.messages.cursor
            : (existing.messages?.cursor ?? null);
    } else if (hasPaginatedData) {
        cursor = existing.messages?.cursor ?? null;
    } else if (hasIncomingMessagesCursor) {
        cursor = incoming.messages.cursor;
    } else {
        cursor = existing.messages?.cursor || null;
    }

    return {
        ...existing,
        ...incoming,
        messages: {
            ...existing.messages,
            ...incoming.messages,
            messages: mergedMessages,
            cursor
        }
    };
}
